












import Vue from "vue";
import Component from "vue-class-component";
//  import 'vue-transition.css'

export default {
  name: "App"
};



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue